import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import { FormattedMessage } from 'react-intl';
import { withStyles } from '@material-ui/core/styles';
import { hasAccessToProduct } from 'utils/permissions';
import { isOnOutreachExperience } from 'embeds/utils/OutreachExperience';
import { Button } from 'embeds/components';
import { ProvisioningEnum } from '@lib/resources/types';
import { messages } from './messages';

export const REFERRAL_INBOUND = 'inbound';
export const REFERRAL_OUTBOUND = 'outbound';

const styles = (theme) => {
  const {
    custom: {
      palette: { colorLightBlue, colorSupportPowder, colorAccentSunrise },
      fontSizes,
    },
    palette: {
      common: { white },
      primary,
    },
    spacing: { unit },
  } = theme;

  return {
    actionsWrapper: {
      display: 'inline-block',
      float: 'right',
      '& button:last-child': {
        marginLeft: unit,
      },
    },
    outbound: {},
    root: {
      display: 'inline-block',
      float: 'left',
      padding: `${unit * 2}px ${unit * 3}px`,
      width: '100%',
    },
    title: {
      color: primary.main,
      float: 'left',
      fontSize: fontSizes.subHeading,
      fontWeight: 900,
      lineHeight: '40px',
      textTransform: 'uppercase',
    },
    toggle: {},
    toggleButtons: {
      display: 'inline-block',
      float: 'left',
      height: 40,
      margin: `0px ${unit * 2}px`,
      position: 'relative',
      '& button:first-child:enabled': {
        borderLeft: 'none !important',
      },
      '& button:disabled': {
        color: primary.main,
        borderColor: `${colorAccentSunrise} !important`,
      },
    },
    togglerButton: {
      backgroundColor: white,
      border: `solid 1px ${colorLightBlue}`,
      float: 'right',
      height: 40,
      position: 'relative',
      transition: 'all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
      width: 110,
      '&$toggle': {
        backgroundColor: `${colorSupportPowder} !important`,
        '&:hover': {
          backgroundColor: `${colorSupportPowder} !important`,
        },
      },
      '&$toggle$outbound': {
        backgroundColor: `${colorAccentSunrise} !important`,
        '&:hover': {
          backgroundColor: `${colorAccentSunrise} !important`,
        },
      },
      '&:hover': {
        backgroundColor: white,
      },
    },
    togglerButtonIcon: {
      fontSize: 16,
      marginRight: unit,
    },
    togglerButtonLabel: {
      fontSize: 16,
      justifyContent: 'center',
      '&$toggle': {
        fontWeight: 600,
      },
    },
  };
};

class ReferralsHeader extends PureComponent {
  handleAddReferral = () => {
    const { referralType } = this.props;
    const url = referralType === REFERRAL_INBOUND ? '/embed/referral/add' : '/embed/referral/outbound/add';

    browserHistory.push(url);
  };

  render() {
    const { classes, permissions, referralType, enabled, settings } = this.props;
    const isToUseOutreachExperienceAndIsntOnOutboundScreen = isOnOutreachExperience(settings);

    return (
      <div className={classes.root}>
        <div className={classes.title}>
          <FormattedMessage
            {...(isToUseOutreachExperienceAndIsntOnOutboundScreen ? messages.outreach : messages.referrals)}
            values={{ type: referralType.toUpperCase() }}
          />
        </div>
        <div className={classes.actionsWrapper}>
          <Button
            color="primary"
            disabled={!enabled}
            key="addButton"
            onClick={this.handleAddReferral}
            variant="contained"
          >
            <FormattedMessage
              {...(isToUseOutreachExperienceAndIsntOnOutboundScreen ? messages.addOutreach : messages.addReferral)}
            />
          </Button>
          {hasAccessToProduct(permissions, ProvisioningEnum.Referral) && referralType === REFERRAL_INBOUND && (
            <Button
              color="primary"
              disabled={!enabled}
              key="uploadButton"
              onClick={() => browserHistory.push('/embed/referrals/upload')}
              variant="contained"
            >
              <FormattedMessage
                {...(isToUseOutreachExperienceAndIsntOnOutboundScreen
                  ? messages.uploadOutreach
                  : messages.uploadReferral)}
              />
            </Button>
          )}
        </div>
      </div>
    );
  }
}

ReferralsHeader.propTypes = {
  classes: PropTypes.object.isRequired,
  enabled: PropTypes.bool.isRequired,
  permissions: PropTypes.object.isRequired,
  referralType: PropTypes.string.isRequired,
};

export default withStyles(styles)(ReferralsHeader);
